import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest,
} from "@/helper/requests"
// import {executeRequest} from "@/store/modules/utils";

const state = {
  promocodes: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: [],
    next: null,
    prev: null,
    error: null,
    lazyItems: [],
    lazyLoading: false,
  }
}

const getters = {
  getPromocodes: state => state.promocodes.items,
  getLazyPromocodes: state => state.promocodes.lazyItems,
  getPromocodesCount: state => state.promocodes.count,
  getPromocodesCurrentUrl: state => state.promocodes.currentUrl,
  getPromocodesNext: state => state.promocodes.next,
  getPromocodesPrev: state => state.promocodes.prev,
  getPromocodesDetail: state => state.promocodes.detail,
  isLoadingPromocodes: state => state.promocodes.loading,
  isLazyLoadingPromocodes: state => state.promocodes.lazyLoading,
  savePromocodesError: state => state.promocodes.error,
}

const actions = {
  loadPromocodes: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.PARTNERS.PROMOCODES.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingPromocodes) {
      commit('SET_PROMOCODES_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_PROMOCODES', data.results)
          commit('SET_PROMOCODES_COUNT', data.count)
          commit('SET_PROMOCODES_CURRENT_URL', url)
          commit('SET_PROMOCODES_NEXT_URL', data.next)
          commit('SET_PROMOCODES_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_PROMOCODES_LOADING_END')
          commit('SAVE_PROMOCODES_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  loadLazyPromocodes: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.PARTNERS.PROMOCODES.LAZY()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingPromocodes) {
      commit('SET_LAZYPROMOCODES_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_LAZYPROMOCODES', data)
          commit('SET_LAZYPROMOCODES_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_LAZYPROMOCODES_LOADING_END')
          commit('SAVE_PROMOCODES_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  userUsedPromocodes: ({ commit }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.PARTNERS.PROMOCODES.USED()
      if (urlAppend) url = urlAppend(url)
    }
    sendGetRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_PROMOCODES_ERROR', data)
        catcher(data, url)
      }
    )
  },
  takePromocode: ({ commit }, { url, id, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) url = url = mendeleev.USER.PARTNERS.PROMOCODES.BIND(id)
    sendGetRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_PROMOCODES_ERROR', data)
        catcher(data, url)
      }
    )
  },
}

const mutations = {
  SET_PROMOCODES: (state, value) => {
    state.promocodes.items = value
  },
  SET_LAZYPROMOCODES: (state, value) => {
    state.promocodes.lazyItems = value
  },
  SET_PROMOCODES_DETAIL: (state, value) => {
    state.promocodes.detail = value
  },
  SET_PROMOCODES_COUNT: (state, value) => {
    state.promocodes.count = value
  },
  SET_PROMOCODES_CURRENT_URL: (state, value) => {
    state.promocodes.currentUrl = value
  },
  SET_PROMOCODES_NEXT_URL: (state, value) => {
    state.promocodes.next = value
  },
  SET_PROMOCODES_PREV_URL: (state, value) => {
    state.promocodes.prev = value
  },
  SET_PROMOCODES_LOADING: (state) => {
    state.promocodes.loading = true
  },
  SET_PROMOCODES_LOADING_END: (state) => {
    state.promocodes.loading = false
  },
  SET_LAZYPROMOCODES_LOADING: (state) => {
    state.promocodes.lazyLoading = true
  },
  SET_LAZYPROMOCODES_LOADING_END: (state) => {
    state.promocodes.lazyLoading = false
  },
  SAVE_PROMOCODES_ERROR: (state, error) => {
    state.promocodes.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
